/**
 * @generated SignedSource<<8bb8d830162a954c8c4da38787098738>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserFollowButton_user$data = {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly viewerIsFollowing: boolean;
  readonly followers: {
    readonly pageInfo: {
      readonly total: number;
    };
  };
  readonly " $fragmentType": "UserFollowButton_user";
};
export type UserFollowButton_user$key = {
  readonly " $data"?: UserFollowButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserFollowButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserFollowButton_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsFollowing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "UserConnection",
      "kind": "LinkedField",
      "name": "followers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "followers(first:1)"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7a55cc7effc8349d70866d06efdc6926";

export default node;
